import axios from "axios";
import { toast } from "react-toastify";
import { getCookie, clearSession } from "../utils/cookies";

class API {
  #isRedirectingToLogin = false;

  constructor() {
     const baseURL =
       process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local'
          ? 'http://localhost:5235'
          // ? 'https://localhost:7080'
        : 'https://api.dev.academetrics.com.br';
       // : 'https://academetrics-back-dev.azurewebsites.net';

    // const baseURL = 'https://academetrics-back-dev.azurewebsites.net';

    this.client = axios.create({
      baseURL,
    });

    this.#injectInterceptors();
  }

  #injectInterceptors() {
    this.client.interceptors.request.use((config) => {
      const token = getCookie("token");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    });

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          // Se já está em página de auth, apenas rejeita o erro sem redirecionar
          // Isso evita loop quando contexts fazem API calls na página de login
          if (window.location.pathname.startsWith("/auth")) {
            return Promise.reject(error);
          }

          // Guard contra múltiplos 401 simultâneos disparando redirect em loop
          if (this.#isRedirectingToLogin) {
            return Promise.reject(error);
          }

          this.#isRedirectingToLogin = true;

          toast("Acesso expirado, faça o login novamente", {
            type: "error"
          });

          // Limpa cookie + localStorage para contextos não reinicializarem com dados antigos
          clearSession();
          window.location.href = "/auth/login";

          return Promise.reject(error);
        }

        throw error;
      }
    );
  }
}

export default new API();
